import React, { useEffect, useState } from "react";
import "../css/chosenImage.css";
import add from "../images/addImage.png";
import cancel from "../images/cancelImage.png";
import ResizableRect from "./Resizable/index";
import Utility from "../js/utility";

import { Common } from "./Canvas";

export default function ChosenImage() {
  useEffect(() => {
    let chosenImageContainer = document.querySelector(".chosenImageContainer");

    if (Common.mobile) {
      chosenImageContainer.addEventListener(
        "touchmove",
        function (ev) {
          if (chosenImageContainer.contains(ev.target)) {
            ev.preventDefault();
          }
        },
        { passive: false }
      );
    }
  }, []);

  const [initial, setInitial] = useState({});

  const [description, setDescription] = useState({
    width: 100,
    height: 100,
    top: 100,
    left: 100,
    rotateAngle: 0,
  });

  useEffect(() => {
    let canvas_container = document.querySelector(".canvasContainer");
    let half_container = canvas_container.clientHeight / 1.6;
    let x = canvas_container.clientWidth / 2 - half_container / 2;
    let y = canvas_container.clientHeight / 2 - half_container / 2;
    let rotate = 0;

    setInitial({
      width: half_container,
      height: half_container,
      left: x,
      top: y,
      rotateAngle: rotate,
    });

    setDescription({
      width: half_container,
      height: half_container,
      left: x,
      top: y,
      rotateAngle: rotate,
    });
  }, []);

  const handleResize = (style, isShiftKey, type) => {
    if (style.width <= 40 || style.height <= 40) return;

    let { top, left, width, height } = style;
    top = Math.round(top);
    left = Math.round(left);
    width = Math.round(width);
    height = Math.round(height);

    setDescription({ ...description, top, left, width, height });
    Utility.setButtonsPosition();
    hideButtons();
  };

  const handleRotate = (rotateAngle) => {
    setDescription({ ...description, rotateAngle });
    Utility.setButtonsPosition();
    hideButtons();
  };

  const rotateEnd = () => {
    Common.rotationAngle = description.rotateAngle;
    showButtons();
  };

  const handleDrag = (deltaX, deltaY) => {
    setDescription({
      ...description,
      left: description.left + deltaX,
      top: description.top + deltaY,
    });
    Utility.setButtonsPosition();
    hideButtons();
  };

  const reset = () => {
    let canvas_container = document.querySelector(".canvasContainer");
    let container_width = canvas_container.clientWidth / 2;
    let container_height = canvas_container.clientHeight / 2;
    let rect = document.querySelector(".rect");
    let rect_width = rect.clientWidth / 2;
    let rect_height = rect.clientHeight / 2;
    let top = container_height - rect_height;
    let left = container_width - rect_width;

    setDescription({
      width: description.width,
      height: description.height,
      top: top,
      left: left,
      rotateAngle: initial.rotateAngle,
    });

    Common.rotationAngle = 0;
  };

  const hideButtons = () => {
    let choose_image_buttons = document.querySelector(".chooseImageButtons");

    choose_image_buttons.classList.add("hideButtons");
  };

  const showButtons = () => {
    let choose_image_buttons = document.querySelector(".chooseImageButtons");

    choose_image_buttons.classList.remove("hideButtons");
  };

  const { width, top, left, height, rotateAngle } = description;
  return (
    <div className="chosenImageContainer">
      <ResizableRect
        left={left}
        top={top}
        width={width}
        height={height}
        rotateAngle={rotateAngle}
        // aspectRatio={false}
        // minWidth={10}
        // minHeight={10}
        zoomable="n, w, s, e, nw, ne, se, sw"
        // rotatable={true}
        // onRotateStart={this.handleRotateStart}
        onRotate={handleRotate}
        onRotateEnd={rotateEnd}
        // onResizeStart={this.handleResizeStart}
        onResize={handleResize}
        onResizeEnd={showButtons}
        // onDragStart={this.handleDragStart}
        onDrag={handleDrag}
        onDragEnd={showButtons}
      />
      <div className="chooseImageButtons">
        <button className="cancelImage" onClick={reset}>
          <img src={cancel} alt="" />
        </button>
        <button className="addImage" onClick={reset}>
          <img src={add} alt="" />
        </button>
      </div>
    </div>
  );
}

// export default function ChosenImage() {
//   let current_angle = 0;

//   useEffect(() => {
//     let gMouseDownX = 0;
//     let gMouseDownY = 0;
//     let gMouseDownOffsetX = 0;
//     let gMouseDownOffsetY = 0;
//     let isResizing = false;
//     let imageWrapperMinimum = 50; // this is minimum dimension of imageWrapper;

//     addListeners();

//     function addListeners() {
//       let imageWrap = document.querySelector(".chosenImageWrapper");
//       imageWrap.addEventListener("mousedown", mouseDown, false);
//       window.addEventListener("mouseup", mouseUp, false);
//     }

//     function mouseUp() {
//       window.removeEventListener("mousemove", containerMove, true);
//     }

//     function mouseDown(e) {
//       gMouseDownX = e.clientX;
//       gMouseDownY = e.clientY;

//       let imageWrap = document.querySelector(".chosenImageWrapper");

//       //The following block gets the X offset (the difference between where it starts and where it was clicked)
//       let leftPart = "";

//       if (!imageWrap.style.left) {
//         let chosenImageWrapper = document.querySelector(".chosenImageWrapper");
//         leftPart += chosenImageWrapper.offsetLeft + "px";
//       }
//       //In case this was not defined as 0px explicitly.
//       else {
//         leftPart = imageWrap.style.left;
//       }
//       let leftPos = leftPart.indexOf("px");
//       let leftNumString = leftPart.slice(0, leftPos); // Get the X value of the object.
//       gMouseDownOffsetX = gMouseDownX - parseInt(leftNumString, 10);

//       //The following block gets the Y offset (the difference between where it starts and where it was clicked)
//       let topPart = "";
//       if (!imageWrap.style.top) {
//         let chosenImageWrapper = document.querySelector(".chosenImageWrapper");

//         topPart += chosenImageWrapper.offsetTop + "px";
//       }
//       //In case this was not defined as 0px explicitly.
//       else topPart = imageWrap.style.top;
//       let topPos = topPart.indexOf("px");
//       let topNumString = topPart.slice(0, topPos); // Get the Y value of the object.
//       gMouseDownOffsetY = gMouseDownY - parseInt(topNumString, 10);

//       window.addEventListener("mousemove", containerMove, true);
//     }

//     function containerMove(e) {
//       if (isResizing) {
//         return;
//       }
//       let imageWrap = document.querySelector(".chosenImageWrapper");

//       let topAmount = e.clientY - gMouseDownOffsetY;
//       imageWrap.style.top = topAmount + "px";
//       let leftAmount = e.clientX - gMouseDownOffsetX;
//       imageWrap.style.left = leftAmount + "px";
//     }

//     // ------------------------------ Resizing image ------------------------------

//     let imageWrapper = document.querySelector(".chosenImageWrapper");
//     let resizers = document.querySelectorAll(".resize");
//     let resizers_length = resizers.length;

//     for (let a = 0; a < resizers_length; a++) {
//       resizers[a].addEventListener("mousedown", mousedown);
//     }

//     let currentResizer;

//     function mousedown(e) {
//       let image_wrapper = document.querySelector(".chosenImageWrapper");
//       // mouse positions relative to viewport, X and Y;
//       let prevX = e.clientX;
//       let prevY = e.clientY;

//       currentResizer = e.target;
//       isResizing = true;

//       window.addEventListener("mousemove", mousemove);
//       window.addEventListener("mouseup", mouseup);
//       imageWrapper.style.transform = "";

//       function mousemove(e) {
//         let rect = imageWrapper.getBoundingClientRect();
//         // "e.clientX" is the new mouse position, the previous mouse X position is "prevX";

//         if (currentResizer.classList.contains("SE")) {
//           let limitLeft = e.clientX > rect.left + imageWrapperMinimum;
//           let limitTop = e.clientY > rect.top + imageWrapperMinimum;
//           // this condition is to limit the minimum width so it won't have 0 width;
//           if (limitLeft) {
//             imageWrapper.style.width = rect.width - (prevX - e.clientX) + "px";
//             imageWrapper.style.left = imageWrapper.offsetLeft + "px";
//           }
//           // this condition is to limit the minimum height so it won't have 0 height;
//           if (limitTop) {
//             imageWrapper.style.height =
//               rect.height - (prevY - e.clientY) + "px";
//             imageWrapper.style.top = imageWrapper.offsetTop + "px";
//           }
//         } else if (currentResizer.classList.contains("SW")) {
//           let limitX = e.clientX + imageWrapperMinimum >= rect.right;
//           let limitY = rect.top + imageWrapperMinimum >= e.clientY;

//           if (!limitX) {
//             imageWrapper.style.width = rect.width + (prevX - e.clientX) + "px";
//             imageWrapper.style.left =
//               imageWrapper.offsetLeft - (prevX - e.clientX) + "px";
//           }
//           if (!limitY) {
//             imageWrapper.style.height =
//               rect.height - (prevY - e.clientY) + "px";
//             imageWrapper.style.top = imageWrapper.offsetTop + "px";
//           }
//         } else if (currentResizer.classList.contains("NW")) {
//           let limitX = e.clientX + imageWrapperMinimum >= rect.right;
//           let limitY = e.clientY >= rect.bottom - imageWrapperMinimum;

//           if (!limitX) {
//             imageWrapper.style.width = rect.width + (prevX - e.clientX) + "px";
//             imageWrapper.style.left =
//               imageWrapper.offsetLeft - (prevX - e.clientX) + "px";
//           }
//           if (!limitY) {
//             imageWrapper.style.height =
//               rect.height + (prevY - e.clientY) + "px";
//             imageWrapper.style.top =
//               imageWrapper.offsetTop - (prevY - e.clientY) + "px";
//           }
//         } else if (currentResizer.classList.contains("NE")) {
//           let limitX = e.clientX >= rect.left + imageWrapperMinimum;
//           let limitY = e.clientY >= rect.bottom - imageWrapperMinimum;

//           if (limitX) {
//             imageWrapper.style.width = rect.width - (prevX - e.clientX) + "px";
//             imageWrapper.style.left = imageWrapper.offsetLeft + "px";
//           }
//           if (!limitY) {
//             imageWrapper.style.height =
//               rect.height + (prevY - e.clientY) + "px";
//             imageWrapper.style.top =
//               imageWrapper.offsetTop - (prevY - e.clientY) + "px";
//           }
//         }

//         prevX = e.clientX;
//         prevY = e.clientY;
//       }

//       function mouseup() {
//         image_wrapper.style.transform = `rotate(${current_angle}deg)`;

//         window.removeEventListener("mousemove", mousemove);
//         window.removeEventListener("mouseup", mouseup);
//         isResizing = false;
//       }
//     }
//   });

//   useEffect(() => {
//     let rotate = document.querySelector(".rotate");

//     rotate.addEventListener("mousedown", mousedown);

//     function mousedown(ev) {
//       ev.stopPropagation();

//       let image_wrapper = document.querySelector(".chosenImageWrapper");
//       let rect_wrapper = image_wrapper.getBoundingClientRect();
//       let box_center = [
//         rect_wrapper.left + image_wrapper.clientWidth / 2,
//         rect_wrapper.top + image_wrapper.clientHeight / 2,
//       ];

//       function mousemove(ev) {
//         let angle =
//           Math.atan2(ev.pageX - box_center[0], -(ev.pageY - box_center[1])) *
//           (180 / Math.PI);
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//         current_angle = angle;

//         image_wrapper.style.transform = `rotate(${angle}deg)`;
//       }

//       function mouseup() {
//         document.removeEventListener("mousemove", mousemove);
//         document.removeEventListener("mouseup", mouseup);
//       }

//       document.addEventListener("mousemove", mousemove);
//       document.addEventListener("mouseup", mouseup);
//     }
//   });

//   return (
//     <div className="chosenImageContainer">
//       <div className="chosenImageWrapper">
//         <div className="chosenImageResizeButtons">
//           <span className="rotate"></span>
//           <span className="resize NW"></span>
//           <span className="resize NE"></span>
//           <span className="resize SW"></span>
//           <span className="resize SE"></span>
//           <img className="chosenImage" src="" alt="" />
//         </div>
//       </div>
//       <div className="chooseImageButtons">
//         <button className="cancelImage">
//           <img src={cancel} alt="" />
//         </button>
//         <button className="addImage">
//           <img src={add} alt="" />
//         </button>
//       </div>
//     </div>
//   );
// }
